if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();

        // Attach navigation handlers directly to buttons with stopPropagation
        // to prevent ModalDialog's pointerup from closing the modal
        const prevBtn = this.querySelector('.product-media-modal__nav--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav--next');

        if (prevBtn) {
          prevBtn.addEventListener('pointerup', (event) => {
            event.stopPropagation();
            this.navigateMedia(-1);
          });
          prevBtn.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('pointerup', (event) => {
            event.stopPropagation();
            this.navigateMedia(1);
          });
          nextBtn.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'center' });

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      navigateMedia(direction) {
        const allMedia = Array.from(
          this.querySelectorAll('[role="document"] [data-media-id]')
        );
        if (allMedia.length <= 1) return;

        const activeMedia = this.querySelector('[role="document"] [data-media-id].active');
        const currentIndex = allMedia.indexOf(activeMedia);
        let newIndex;

        if (direction === -1) {
          newIndex = currentIndex <= 0 ? allMedia.length - 1 : currentIndex - 1;
        } else {
          newIndex = currentIndex >= allMedia.length - 1 ? 0 : currentIndex + 1;
        }

        this.switchToMedia(allMedia[newIndex]);
      }

      switchToMedia(targetMedia) {
        this.querySelectorAll('[role="document"] [data-media-id]').forEach((el) => {
          el.classList.remove('active');
        });

        targetMedia.classList.add('active');
        targetMedia.scrollIntoView({ block: 'center' });

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (targetMedia.width - container.clientWidth) / 2;

        if (targetMedia.nodeName === 'DEFERRED-MEDIA') {
          const template = targetMedia.querySelector('template');
          if (template && template.content.querySelector('.js-youtube')) {
            targetMedia.loadContent();
          }
        }
      }
    }
  );
}
